import Ecommerce from "Components/Pages/Ecommerce";
import Error403 from "Components/Pages/ErrorPages/ErrorPage403";
import AppLayout from "Layout/Layout";
import { Navigate, NonIndexRouteObject } from "react-router";

const dashboardRouters: NonIndexRouteObject[] = [
  {
    path: "/",
    element: <Navigate to="/trang-chu" />,
  },
  {
    path: "/403",
    element: <Error403 />,
  },
  {
    path: "/trang-chu",
    element: (
      <AppLayout>
        <Ecommerce />
      </AppLayout>
    ),
  },
];

export default dashboardRouters;
